<template>
  <div class="loading-overlay">
    <img src="@/assets/loading.svg" class="img-fluid" alt="loading">
  </div>
</template>

<script>
export default {
  name: "LoadingOverlay"
}
</script>
